import { StatelessPayload } from '..';

export const encodeStateless = (type: StatelessPayload['type'], data?: any, objectId?: string): string => {
    return JSON.stringify({ type, data, objectId });
};

export const decodeStateless = (data: string): StatelessPayload | null => {
    try {
        const json = JSON.parse(data);
        return json;
    } catch (e) {
        return null;
    }
};
